
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"currentColor","stroke":"currentColor","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{staticClass:"cls-4",attrs:{"d":"M-2076.433-1760.538h7.4a2.484 2.484 0 002.5-2.468v-1.827a.741.741 0 00-1.483 0v1.827a1 1 0 01-1.016.985h-7.4a.988.988 0 01-1-.985v-13.988a.988.988 0 011-.985h7.4a1 1 0 011.016.985v2.124a.741.741 0 001.483 0v-2.124a2.486 2.486 0 00-2.5-2.468h-7.4a2.472 2.472 0 00-2.485 2.468v13.993a2.471 2.471 0 002.485 2.463z"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M-2064.152-1772.773a.74.74 0 11.994-1.094l3.833 3.462a.74.74 0 010 1.1l-3.833 3.462a.749.749 0 01-.5.192.739.739 0 01-.549-.244.75.75 0 01.052-1.055l2.4-2.18-10.634.017a.741.741 0 110-1.483l10.634-.017z"}})])])
          )
        }
      }
    